import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Combina clases de Tailwind con merge inteligente (última wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
